import { Client } from "./client";

export class User {
    Email: string;
    Password: string;
    Phone: string;
    FirstName: string;
    LastName: string;

    CompanyName: string;
    ServerKey: string;
    ClientKey: string;

    ClientList: Client[] = [];
    IsExternal: boolean;

    static mapFromJSON(json) {
        const m = new User();

        m.ServerKey = json['serverKey'];
        m.ClientKey = json['clientKey'];

        m.FirstName = json['firstName'];
        m.LastName = json['lastName'];
        m.CompanyName = json['companyName'];
        m.Phone = json['phone'];
        m.Email = json['email'];
        m.IsExternal = json['isExternal'];
        
        if (json['clientList']) {
            m.ClientList = json['clientList'].map(item => Client.mapFromJSON(item));
        }

        return m;
    }
}
